import { FC, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../../../../auth';



interface Document {
    docType: string;
    docUrl: string;
    docNumber: string | null;
}

// Transaction details interface
interface TransactionDetail {
    createdAt?: number;
    date?: number;
    transactionId?: string;
    amount?: number;
    receipt?: string;
    documents?: Document[];
}

// Payment details interface
interface PaymentDetail {
    paymentType: string;
    amount: number;
    netPayable: number;
    taxAmount: number;
    remainingPayable: number;
    totalAmount: number;
    paymentDate: number;
    debitNote: {
        price: number;
        noteType: string;
    };
    documents: Document[];
    transactionDetails?: TransactionDetail[];
}

// User interface
interface User {
    orderId: string;
    payment?: {
        paymentDetails?: PaymentDetail[];
    };
}

// Component props interface
interface UserTableModalProps {
    user: User;
    onClose: () => void;
    show: boolean;
}

// Invoice data interface
interface InvoiceData {
    data: {
        paymentDetails: PaymentDetail[];
    };
}


export const PaymentInfoPopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const [invoiceData, setInvoiceData] = useState<InvoiceData | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const { currentUser } = useAuth()
    // console.log(currentUser.userType)z

    useEffect(() => {
        const fetchInvoiceData = async () => {
            if (!show || !user.orderId) return;

            setIsLoading(true);
            setError(null);

            try {
                const response = await fetch(
                    `https://pfc-backend-api.asmglobal.co.in/v1/api/dispatchOrders/${user.orderId}/invoice`
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                setInvoiceData(data);
            } catch (err) {
                setError(err instanceof Error ? err.message : 'Failed to fetch invoice data');
            } finally {
                setIsLoading(false);
            }
        };

        fetchInvoiceData();
    }, [show, user.orderId]);

    // const recyclerPayment = invoiceData?.data?.paymentDetails.find(
    //     payment => payment.paymentType === 'SUPPLIER'

    // const recyclerPayment = invoiceData?.data?.paymentDetails.find(
    //     payment => payment.paymentType === (
    //         currentUser && typeof currentUser === 'object' && currentUser !== null &&
    //             'userType' in currentUser ?
    //             ((currentUser as any).userType === 'RECYCLER' ? 'RECYCLER' : 'SMART_CENTRE') :
    //             'SUPPLIER'
    //     )
    // );


    const recyclerPayment = invoiceData?.data?.paymentDetails.find(
        payment => payment.paymentType === (
            currentUser && typeof currentUser === 'object' && currentUser !== null &&
                'userType' in currentUser ?
                ((currentUser as any).userType === 'RECYCLER' ? 'RECYCLER' :
                    (currentUser as any).userType === 'SMART_CENTRE' ? 'SUPPLIER' :
                        'SUPPLIER') :
                'SUPPLIER'
        )
    );

    const formatDate = (timestamp: number) => {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        return `${day}/${month}/${year}`;
    };

    return (
        <Modal
            className="modal fade"
            id="kt_modal_view_user"
            data-backdrop="static"
            tabIndex={-1}
            role="dialog"
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div
                        className="btn btn-sm btn-icon btn-active-color-primary"
                        onClick={onClose}
                    >
                        ×
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Payment Info</h1>
                    </div>

                    {isLoading && (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}

                    {/* {recyclerPayment && (
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr>
                                        <th>Amount</th>
                                        <th>Adjustment</th>
                                        <th>Tax</th>
                                        <th>Net Payable</th>
                                        <th>Balance</th>
                                        <th>Invoice</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{invoiceData?.data?.paymentDetails.amount.toLocaleString()}</td>
                                        <td>{recyclerPayment?.debitNote?.noteType.toLocaleString()}
                                            {" "}
                                            ({recyclerPayment?.debitNote?.price})
                                        </td>
                                        <td>{recyclerPayment?.taxAmount}</td>
                                        <td>{recyclerPayment?.totalAmount}</td>
                                        <td>{recyclerPayment?.remainingPayable}</td>
                                        <td>
                                            {recyclerPayment?.documents.map((doc, index) => (
                                                doc.docType === 'INVOICE' && (
                                                    <i
                                                        key={index}
                                                        className="bi bi-file-pdf text-danger cursor-pointer"
                                                        style={{ fontSize: '3rem' }}
                                                        onClick={() => window.open(doc.docUrl, '_blank')}
                                                        title="View PDF"
                                                    ></i>
                                                )
                                            ))}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )} */}


                    {/* for reciviables  */}

                    {(() => {
                        // Check if we're in one of the specific locations
                        const currentPath = window.location.pathname;
                        const allowedPaths = [
                            '/apps/finance/receivables',
                            '/apps/sales/ReceivablesSalesAdmin',
                            'apps/transactions/receivables-recycler'
                        ];

                        const isAllowedPath = allowedPaths.some(path => currentPath.includes(path));

                        // Only continue if we're in an allowed path
                        if (!isAllowedPath) return null;

                        const recyclerPayment = invoiceData?.data?.paymentDetails.find(payment => payment.paymentType === 'RECYCLER');

                        return recyclerPayment && (
                            <div className="table-responsive">
                                {/* <table className="table table-bordered">
                                    <thead style={{ backgroundColor: '#BFD7ED' }}>
                                        <tr>
                                            <th>Amount</th>
                                            <th>Adjustment</th>
                                            <th>Tax</th>
                                            <th>Net Payable</th>
                                            <th>Balance</th>
                                            <th>Invoice</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{recyclerPayment.amount.toLocaleString()}</td>
                                            <td>
                                                {recyclerPayment?.debitNote?.noteType.toLocaleString()}
                                                {" "}
                                                ({recyclerPayment?.debitNote?.price})
                                            </td>
                                            <td>{recyclerPayment?.taxAmount}</td>
                                            <td>{recyclerPayment?.totalAmount}</td>
                                            <td>{recyclerPayment?.remainingPayable}</td>
                                            <td>
                                                {recyclerPayment?.documents.map((doc, index) => (
                                                    doc.docType === 'INVOICE' && (
                                                        <i
                                                            key={index}
                                                            className="bi bi-file-pdf text-danger cursor-pointer"
                                                            style={{ fontSize: '3rem' }}
                                                            onClick={() => window.open(doc.docUrl, '_blank')}
                                                            title="View PDF"
                                                        ></i>
                                                    )
                                                ))}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> */}

                                <div className="table-responsive">
                                    <table style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        marginBottom: "20px",
                                        border: "1px solid #ddd"
                                    }}>
                                        <thead>
                                            <tr>
                                                <th colSpan={2} style={{
                                                    backgroundColor: "#BFD7ED",
                                                    color: "black",
                                                    fontWeight: "bold",
                                                    padding: "12px",
                                                    textAlign: "left",
                                                    border: "1px solid #ddd"
                                                }}>
                                                    Payment Details
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{
                                                    width: "33%",
                                                    padding: "10px",
                                                    border: "1px solid #ddd",
                                                    fontWeight: "bold"
                                                }}>
                                                    Amount (INR)
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment.amount?.toLocaleString() || 'N/A'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{
                                                    fontWeight: "bold",
                                                    padding: "10px",
                                                    border: "1px solid #ddd"
                                                }}>
                                                    Adjustment
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.debitNote?.noteType?.toLocaleString() || 'N/A'} ({recyclerPayment?.debitNote?.price || '0'})
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{
                                                    fontWeight: "bold",
                                                    padding: "10px",
                                                    border: "1px solid #ddd"
                                                }}>
                                                    Tax
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.taxAmount || 'N/A'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{
                                                    fontWeight: "bold",
                                                    padding: "10px",
                                                    border: "1px solid #ddd"
                                                }}>
                                                    Net Payable
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.totalAmount || 'N/A'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{
                                                    fontWeight: "bold",
                                                    padding: "10px",
                                                    border: "1px solid #ddd"
                                                }}>
                                                    Balance
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.remainingPayable}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{
                                                    fontWeight: "bold",
                                                    padding: "10px",
                                                    border: "1px solid #ddd"
                                                }}>
                                                    Invoice
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.documents?.some(doc => doc.docType === 'INVOICE') ? (
                                                        recyclerPayment.documents.map((doc, index) =>
                                                            doc.docType === 'INVOICE' && (
                                                                <i
                                                                    key={index}
                                                                    className="bi bi-file-pdf text-danger cursor-pointer"
                                                                    style={{ fontSize: '2rem', marginRight: '10px' }}
                                                                    onClick={() => window.open(doc.docUrl, '_blank')}
                                                                    title="View PDF"
                                                                ></i>
                                                            )
                                                        )
                                                    ) : 'N/A'}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        );
                    })()}

                    {/* for paybles  */}


                    {(() => {
                        // Check if we're in one of the specific locations
                        const currentPath = window.location.pathname;
                        const allowedPaths = [
                            'apps/finance/payablesFinance',
                            'apps/logic/payables',
                            'apps/purchase/PayablesPurchaseAdmin'
                        ];

                        const isAllowedPath = allowedPaths.some(path => currentPath.includes(path));

                        // Only continue if we're in an allowed path
                        if (!isAllowedPath) return null;

                        const recyclerPayment = invoiceData?.data?.paymentDetails.find(payment => payment.paymentType === 'SUPPLIER');

                        return recyclerPayment && (
                            <div className="table-responsive">
                                {/* <table className="table table-bordered">
                                    <thead style={{ backgroundColor: '#BFD7ED' }}>
                                        <tr>
                                            <th>Amount (INR)</th>
                                            <th>Adjustment</th>
                                            <th>Tax</th>
                                            <th>Net Payable</th>
                                            <th>Balance</th>
                                            <th>Invoice</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{recyclerPayment.amount.toLocaleString()}</td>
                                            <td>
                                                {recyclerPayment?.debitNote?.noteType.toLocaleString()}
                                                {" "}
                                                ({recyclerPayment?.debitNote?.price})
                                            </td>
                                            <td>{recyclerPayment?.taxAmount}</td>
                                            <td>{recyclerPayment?.totalAmount}</td>
                                            <td>{recyclerPayment?.remainingPayable}</td>
                                            <td>
                                                {recyclerPayment?.documents.map((doc, index) => (
                                                    doc.docType === 'INVOICE' && (
                                                        <i
                                                            key={index}
                                                            className="bi bi-file-pdf text-danger cursor-pointer"
                                                            style={{ fontSize: '3rem' }}
                                                            onClick={() => window.open(doc.docUrl, '_blank')}
                                                            title="View PDF"
                                                        ></i>
                                                    )
                                                ))}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> */}
                                <div className="table-responsive">
                                    <table style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        marginBottom: "20px",
                                        border: "1px solid #ddd"
                                    }}>
                                        <thead>
                                            <tr>
                                                <th colSpan={2} style={{
                                                    backgroundColor: "#BFD7ED",
                                                    color: "black",
                                                    fontWeight: "bold",
                                                    padding: "12px",
                                                    textAlign: "left",
                                                    border: "1px solid #ddd"
                                                }}>
                                                    Payment Summary
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "30%", padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                                    Amount (INR)
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment.amount?.toLocaleString() || 'N/A'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                                    Adjustment
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.debitNote?.noteType?.toLocaleString() || 'N/A'} ({recyclerPayment?.debitNote?.price || 'N/A'})
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                                    Tax
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.taxAmount || 'N/A'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                                    Net Payable
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.totalAmount || 'N/A'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                                    Balance
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.remainingPayable || 'N/A'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "10px", border: "1px solid #ddd", fontWeight: "bold" }}>
                                                    Invoice
                                                </td>
                                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                    {recyclerPayment?.documents?.filter(doc => doc.docType === 'INVOICE')?.length > 0 ? (
                                                        recyclerPayment.documents.map((doc, index) => (
                                                            doc.docType === 'INVOICE' && (
                                                                <i
                                                                    key={index}
                                                                    className="bi bi-file-pdf text-danger cursor-pointer"
                                                                    style={{ fontSize: '2rem', marginRight: '10px' }}
                                                                    onClick={() => window.open(doc.docUrl, '_blank')}
                                                                    title="View PDF"
                                                                ></i>
                                                            )
                                                        ))
                                                    ) : (
                                                        'N/A'
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        );
                    })()}






                    <div className="mt-5">
                        {/* <h4 className="mb-3">Payment History </h4> */}
                        {/* <div className="table-responsive">
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' // This helps maintain consistent column widths
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Date</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>UTR Number</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Amount (INR)</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Receipt </th>
                                    </tr>
                                </thead>


            
                                <tbody>
                                    {(() => {
                                       
                                        const currentPath = window.location.pathname;
                                        const allowedPaths = [
                                            '/apps/transactions/receivables-recycler',
                                            '/apps/sales/ReceivablesSalesAdmin',
                                            '/apps/finance/receivables'
                                        ];

                                        const isAllowedPath = allowedPaths.some(path => currentPath.includes(path));

                                       
                                        if (!isAllowedPath) {
                                            return null;
                                        }

                                        
                                        const recyclerPayment = user?.payment?.paymentDetails?.find(payment => payment.paymentType === 'RECYCLER');

                                        return recyclerPayment?.transactionDetails
                                            ? recyclerPayment.transactionDetails.map((transaction, index) => (
                                                <tr key={index}>
                                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.createdAt ? new Date(transaction.createdAt).toLocaleDateString() : 'N/A'}</td>
                                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.transactionId || 'N/A'}</td>
                                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.amount ? transaction.amount.toLocaleString() : 'N/A'}</td>
                                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                                        {transaction.documents && transaction.documents.length > 0 ? (
                                                            <div className="d-flex gap-2">
                                                                {transaction.documents.map((doc, idx) => (
                                                                    <div key={idx} style={{ width: '200px', height: '120px' }}>
                                                                        <img
                                                                            src={doc.docUrl}
                                                                            alt={`Receipt ${idx + 1}`}
                                                                            className="cursor-pointer"
                                                                            onClick={() => window.open(doc.docUrl, '_blank')}
                                                                            style={{
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                objectFit: 'cover',
                                                                                border: '1px solid #eee',
                                                                                borderRadius: '4px'
                                                                            }}
                                                                            onError={(e) => {
                                                                                e.currentTarget.src = '/media/avatars/blank.png';
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            'N/A'
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                            : (
                                                <tr>
                                                    <td
                                                        colSpan={4}
                                                        style={{
                                                            padding: '10px',
                                                            textAlign: 'center',
                                                            border: '1px solid #ddd'
                                                        }}
                                                    >
                                                        No payment details found
                                                    </td>
                                                </tr>
                                            );
                                    })()}
                                </tbody>

                            </table>

                              

                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' 
                            }}>
                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                    <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Date</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>UTR Number</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Amount (INR)</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Receipt </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {(() => {
                                       
                                        const currentPath = window.location.pathname;
                                        const allowedPaths = [
                                            '/apps/finance/payablesFinance',
                                            '/apps/logic/payables',
                                            '/apps/purchase/PayablesPurchaseAdmin',
                                        ];

                                        const isAllowedPath = allowedPaths.some(path => currentPath.includes(path));

                                        
                                        if (!isAllowedPath) {
                                            return null; 
                                        }

                                       
                                        const recyclerPayment = user?.payment?.paymentDetails?.find(payment => payment.paymentType === 'SUPPLIER');

                                        return recyclerPayment?.transactionDetails
                                            ? recyclerPayment.transactionDetails.map((transaction, index) => (
                                                <tr key={index}>


                                                    <td style={{
                                                        padding: '10px', textAlign: 'left', borderTop: '1px solid #ddd',
                                                        borderBottom: '1px solid #ddd',
                                                        borderLeft: '1px solid #ddd',
                                                        borderRight: '1px solid #ddd'
                                                    }}>{transaction.createdAt ? new Date(transaction.createdAt).toLocaleDateString() : 'N/A'}</td>



                                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.transactionId || 'N/A'}</td>
                                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.amount ? transaction.amount.toLocaleString() : 'N/A'}</td>
                                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                                        {transaction.documents && transaction.documents.length > 0 ? (
                                                            <div className="d-flex gap-2">
                                                                {transaction.documents.map((doc, idx) => (
                                                                    <div key={idx} style={{ width: '200px', height: '120px' }}>
                                                                        <img
                                                                            src={doc.docUrl}
                                                                            alt={`Receipt ${idx + 1}`}
                                                                            className="cursor-pointer"
                                                                            onClick={() => window.open(doc.docUrl, '_blank')}
                                                                            style={{
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                objectFit: 'cover',
                                                                                border: '1px solid #eee',
                                                                                borderRadius: '4px'
                                                                            }}
                                                                            onError={(e) => {
                                                                                e.currentTarget.src = '/media/avatars/blank.png';
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            'N/A'
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                            : (
                                                <tr>
                                                    <td
                                                        colSpan={4}
                                                        style={{
                                                            padding: '10px',
                                                            textAlign: 'center',
                                                            border: '1px solid #ddd'
                                                        }}
                                                    >
                                                        No payment details found
                                                    </td>
                                                </tr>
                                            );
                                    })()}
                                </tbody>




                            </table>




                            
                        </div> */}

                        <div className="mt-5">
                            <h4 className="mb-3">Payment History</h4>
                            <div className="table-responsive">

                                {/* First condition for recycler paths - ENTIRE TABLE inside condition */}
                                {(() => {
                                    const currentPath = window.location.pathname;
                                    const allowedRecyclerPaths = [
                                        '/apps/transactions/receivables-recycler',
                                        '/apps/sales/ReceivablesSalesAdmin',
                                        '/apps/finance/receivables'
                                    ];

                                    if (allowedRecyclerPaths.some(path => currentPath.includes(path))) {
                                        // Find the RECYCLER payment
                                        const recyclerPayment = user?.payment?.paymentDetails?.find(payment => payment.paymentType === 'RECYCLER');

                                        return (
                                            <table style={{
                                                width: '100%',
                                                borderCollapse: 'collapse',
                                                marginBottom: '20px',
                                                tableLayout: 'fixed'
                                            }}>
                                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                                    <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Date</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>UTR Number</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Amount (INR)</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Receipt</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {recyclerPayment?.transactionDetails
                                                        ? recyclerPayment.transactionDetails.map((transaction, index) => (
                                                            <tr key={index}>
                                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.createdAt ? new Date(transaction.createdAt).toLocaleDateString('en-GB') : 'N/A'}</td>
                                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.transactionId || 'N/A'}</td>
                                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.amount ? transaction.amount.toLocaleString() : 'N/A'}</td>
                                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                                                    {transaction.documents && transaction.documents.length > 0 ? (
                                                                        <div className="d-flex gap-2">
                                                                            {transaction.documents.map((doc, idx) => (
                                                                                <div key={idx} style={{ width: '200px', height: '120px' }}>
                                                                                    <img
                                                                                        src={doc.docUrl}
                                                                                        alt={`Receipt ${idx + 1}`}
                                                                                        className="cursor-pointer"
                                                                                        onClick={() => window.open(doc.docUrl, '_blank')}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            height: '100%',
                                                                                            objectFit: 'cover',
                                                                                            border: '1px solid #eee',
                                                                                            borderRadius: '4px'
                                                                                        }}
                                                                                        onError={(e) => {
                                                                                            e.currentTarget.src = '/media/avatars/blank.png';
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    ) : (
                                                                        'N/A'
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                        : (
                                                            <tr>
                                                                <td colSpan={4} style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>No payment details found</td>
                                                            </tr>
                                                        )}
                                                </tbody>
                                            </table>
                                        );
                                    }
                                    return null;
                                })()}

                                {/* Second condition for supplier paths - ENTIRE TABLE inside condition */}
                                {(() => {
                                    const currentPath = window.location.pathname;
                                    const allowedSupplierPaths = [
                                        '/apps/finance/payablesFinance',
                                        '/apps/logic/payables',
                                        '/apps/purchase/PayablesPurchaseAdmin',
                                    ];

                                    if (allowedSupplierPaths.some(path => currentPath.includes(path))) {
                                        // Find the SUPPLIER payment
                                        const supplierPayment = user?.payment?.paymentDetails?.find(payment => payment.paymentType === 'SUPPLIER');

                                        return (
                                            <table style={{
                                                width: '100%',
                                                borderCollapse: 'collapse',
                                                marginBottom: '20px',
                                                tableLayout: 'fixed'
                                            }}>
                                                <thead style={{ backgroundColor: '#BFD7ED' }}>
                                                    <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Date</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>UTR Number</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Amount (INR)</th>
                                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Receipt</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {supplierPayment?.transactionDetails
                                                        ? supplierPayment.transactionDetails.map((transaction, index) => (
                                                            <tr key={index}>
                                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.createdAt ? new Date(transaction.createdAt).toLocaleDateString('en-GB') : 'N/A'}</td>
                                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.transactionId || 'N/A'}</td>
                                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{transaction.amount ? transaction.amount.toLocaleString() : 'N/A'}</td>
                                                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                                                    {transaction.documents && transaction.documents.length > 0 ? (
                                                                        <div className="d-flex gap-2">
                                                                            {transaction.documents.map((doc, idx) => (
                                                                                <div key={idx} style={{ width: '200px', height: '120px' }}>
                                                                                    <img
                                                                                        src={doc.docUrl}
                                                                                        alt={`Receipt ${idx + 1}`}
                                                                                        className="cursor-pointer"
                                                                                        onClick={() => window.open(doc.docUrl, '_blank')}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            height: '100%',
                                                                                            objectFit: 'cover',
                                                                                            border: '1px solid #eee',
                                                                                            borderRadius: '4px'
                                                                                        }}
                                                                                        onError={(e) => {
                                                                                            e.currentTarget.src = '/media/avatars/blank.png';
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    ) : (
                                                                        'N/A'
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                        : (
                                                            <tr>
                                                                <td colSpan={4} style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>No payment details found</td>
                                                            </tr>
                                                        )}
                                                </tbody>
                                            </table>
                                        );
                                    }
                                    return null;
                                })()}

                            </div>
                        </div>
                    </div>





                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal >
    );
};

export default PaymentInfoPopUp;




































// import { FC, useEffect, useState } from 'react';
// import { Modal } from 'react-bootstrap';

// // Transaction details interface
// interface TransactionDetail {
//     createAt?: number;
//     date?: number;
//     transactionId?: string;
//     amount?: number;
//     receipt?: string;
//     documents?: {
//         docType: string;
//         docUrl: string;
//         docNumber: string | null;
//     }[];
// }

// // Payment details interface
// interface PaymentDetail {
//     paymentType: string;
//     amount: number;
//     netPayable: number;
//     paymentDate: number;
//     debitNote: {
//         price: number;
//         noteType: string;
//     };
//     documents: {
//         docType: string;
//         docUrl: string;
//         docNumber: string | null;
//     }[];
//     transactionDetails?: TransactionDetail[];
// }

// Component props interface
// interface UserTableModalProps {
//     user: {
//         orderId: string;
//         payment?: {
//             paymentDetails?: PaymentDetail[];
//         };
//     };
//     onClose: () => void;
//     show: boolean;
// }

// // // Invoice data interface
// // interface InvoiceData {
// //     data: {
// //         paymentDetails: PaymentDetail[];
// //     };
// // }

// export const PaymentInfoPopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
//     const [invoiceData, setInvoiceData] = useState<InvoiceData | null>(null);
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState<string | null>(null);

//     useEffect(() => {
//         const fetchInvoiceData = async () => {
//             if (!show || !user.orderId) return;

//             setIsLoading(true);
//             setError(null);

//             try {
//                 const response = await fetch(
//                     `https://pfc-backend-api.asmglobal.co.in/v1/api/dispatchOrders/${user.orderId}/invoice`
//                 );

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`);
//                 }

//                 const data = await response.json();
//                 setInvoiceData(data);
//             } catch (err) {
//                 setError(err instanceof Error ? err.message : 'Failed to fetch invoice data');
//             } finally {
//                 setIsLoading(false);
//             }
//         };

//         fetchInvoiceData();
//     }, [show, user.orderId]);

//     const recyclerPayment = invoiceData?.data?.paymentDetails.find(
//         payment => payment.paymentType === 'RECYCLER'
//     );

//     const formatDate = (timestamp: number) => {
//         const date = new Date(timestamp);
//         const day = String(date.getDate()).padStart(2, '0');
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const year = String(date.getFullYear()).slice(-2);
//         return `${day}/${month}/${year}`;
//     };

//     return (
//         <Modal
//             className="modal fade"
//             id="kt_modal_view_user"
//             data-backdrop="static"
//             tabIndex={-1}
//             role="dialog"
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div
//                         className="btn btn-sm btn-icon btn-active-color-primary"
//                         onClick={onClose}
//                     >
//                         ×
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">Payment Info</h1>
//                     </div>

//                     {isLoading && (
//                         <div className="text-center">
//                             <div className="spinner-border" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                             </div>
//                         </div>
//                     )}

//                     {error && (
//                         <div className="alert alert-danger" role="alert">
//                             {error}
//                         </div>
//                     )}

//                     {recyclerPayment && (
//                         <div className="table-responsive">
//                             <table className="table table-bordered">
//                                 <thead style={{ backgroundColor: '#BFD7ED' }}>
//                                     <tr>
//                                         <th>Amount</th>
//                                         <th>Adjustment</th>
//                                         <th>Net Payable</th>
//                                         <th>Due Date</th>
//                                         <th>Invoice</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr>
//                                         <td>{recyclerPayment.amount.toLocaleString()}</td>
//                                         <td>{recyclerPayment.debitNote.noteType.toLocaleString()}</td>
//                                         <td>{recyclerPayment.netPayable.toLocaleString()}</td>
//                                         <td>{formatDate(recyclerPayment.paymentDate)}</td>
//                                         <td>
//                                             {recyclerPayment.documents.map((doc, index) => (
//                                                 doc.docType === 'INVOICE' && (
//                                                     <i
//                                                         key={index}
//                                                         className="bi bi-file-pdf text-danger cursor-pointer"
//                                                         style={{ fontSize: '3rem' }}
//                                                         onClick={() => window.open(doc.docUrl, '_blank')}
//                                                         title="View PDF"
//                                                     ></i>
//                                                 )
//                                             ))}
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>
//                     )}

//                     {/* Transaction Details Table */}
//                     <div className="mt-5">
//                         <h4 className="mb-3">Transaction Details</h4>
//                         <div className="table-responsive">
//                             <table className="table table-rounded table-striped border gy-7 gs-7">
//                                 <thead>
//                                     <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
//                                         <th>Date</th>
//                                         <th>UTR Number</th>
//                                         <th>Amount</th>
//                                         <th>Receipt</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {user?.payment?.paymentDetails
//                                         ?.filter(payment => payment.paymentType === "SUPPLIER")
//                                         .flatMap(payment =>
//                                             payment.transactionDetails
//                                                 ? payment.transactionDetails.map((transaction, index) => (
//                                                     <tr key={index}>
//                                                         <td>{transaction.createAt ? new Date(transaction.createAt).toLocaleDateString() : 'N/A'}</td>
//                                                         <td>{transaction.transactionId || 'N/A'}</td>
//                                                         <td>{transaction.amount ? transaction.amount.toLocaleString() : 'N/A'}</td>
//                                                         <td>
//                                                             {transaction.documents && transaction.documents.length > 0 ? (
//                                                                 <div className="d-flex gap-2">
//                                                                     {transaction.documents.map((doc, idx) => (
//                                                                         <div key={idx} style={{ width: '200px', height: '120px' }}>
//                                                                             <img
//                                                                                 src={doc.docUrl}
//                                                                                 alt={`Receipt ${idx + 1}`}
//                                                                                 className="cursor-pointer"
//                                                                                 onClick={() => window.open(doc.docUrl, '_blank')}
//                                                                                 style={{
//                                                                                     width: '200%',
//                                                                                     height: '150%',
//                                                                                     objectFit: 'cover',
//                                                                                     border: '1px solid #eee',
//                                                                                     borderRadius: '4px'
//                                                                                 }}
//                                                                                 onError={(e) => {
//                                                                                     e.currentTarget.src = '/media/avatars/blank.png';
//                                                                                 }}
//                                                                             />
//                                                                         </div>
//                                                                     ))}
//                                                                 </div>
//                                                             ) : (
//                                                                 'N/A'
//                                                             )}
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                                 : [(
//                                                     <tr key="no-transactions">
//                                                         <td colSpan={4} className="text-center">No transaction details available</td>
//                                                     </tr>
//                                                 )]
//                                         ) || (
//                                             <tr>
//                                                 <td colSpan={4} className="text-center">No supplier payment details found</td>
//                                             </tr>
//                                         )}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>

//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={onClose}
//                         >
//                             Close
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };

// export default PaymentInfoPopUp;